import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import {
  LastPage,
  AllInclusive,
  Add,
  MoreVert,
  Schedule,
  Block,
  Subway,
  AirportShuttle,
  Edit,
  Delete,
  Done,
  Image,
  MonetizationOn,
  AttachMoney
} from "@material-ui/icons";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,DatePicker
} from "@material-ui/pickers";

import {
  TableRow,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  Grid,
  List,ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  CircularProgress,
  FormHelperText,Stepper,Step,StepLabel, Icon
} from "@material-ui/core";

import { withLocalize, Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import API from './api';

import API_ADMIN from './api_admin';

import UserInfo from "./login_info";

import { useSnackbar } from 'notistack';

import axios from 'axios';

import {TransportService,AdminService} from "./../../utils/web_config_2";

import {useHistory } from "react-router-dom";

import Skeleton from '@material-ui/lab/Skeleton';

import Pagination from '@material-ui/lab/Pagination';

import Format from "date-fns/format";


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  type_list:{
    backgroundColor: theme.palette.background.paper,
  },
  btn: {
    textTransform: "capitalize",
    margin:theme.spacing(1),
    fontWeight:"bold"
  },
  title: {
    textTransform: "capitalize",
    margin:theme.spacing(1)
  },
  formTitle: {
    flexGrow: 1,
  },
}));

function Commissions() {
  const classes = useStyles1();
  const [message,setMessage]=useState("Loading...");


  const [operatorData, setOperatorData] = useState({});
  
  const history = useHistory();


  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  // new vehicle dialog

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  
  
   useEffect(()=>{
    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    setOperatorData(data);
    axios.defaults.baseURL = new AdminService().BASE_URL;

    get_commission(data.token);

    console.log("org id",new UserInfo().ORG_ID)

   },[]);



  //  get Commissions

  const [commissionLoad,setCommissionLoad]=useState(false);
  const [commissions,setCommissions]=useState([]);
  const get_commission=(token)=>{
    setCommissionLoad(true);
    const commissionInstance = axios.create(new AdminService().setHeaders(token));
    commissionInstance.get('/api/v1/organization-commission/organization/'+new UserInfo().ORG_ID)
    .then(res=>{
    var objs=res.data.data;
    if(objs.length==0){
      setMessage("No commissions available!");
    }
    setCommissions(objs);
    setCommissionLoad(false);
    })
    .catch(err=>{

      if(err.message){
        enqueueSnackbar(err.message, { 
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
          });
      }


      if(err.response){
        
        if(err.response.status==401){
          history.push("/", { expired: true });
          enqueueSnackbar(err.message, { 
            variant: 'error',
        });
        }

        enqueueSnackbar(err.response.data.message, { 
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
          });
      }

    });
  }


  return (
    <div className={classes.root}>

     <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}> <MonetizationOn fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Commissions</b></Typography>

 </Box>
 </Box>

<Box>

  {commissionLoad?
  <Grid container spacing={2}>
  <Grid item md={2} lg={2} xs={6} sm={3}>
      <Box   height="120px" >
      <Skeleton variant="rect" width="100%" style={{borderRadius:"10px"}} height="100%">
        </Skeleton>
      </Box>
  </Grid>
  <Grid item md={2} lg={2} xs={6} sm={3}>
      <Box   height="120px" >
      <Skeleton variant="rect" width="100%" style={{borderRadius:"10px"}} height="100%">
        </Skeleton>
      </Box>
  </Grid>
</Grid>
:
<Grid container spacing={2}>
  {commissions.map((c)=>{
    return <Grid item md={2} lg={2} xs={6} sm={3}>
    <Box bgcolor="white"  height="120px" style={{borderRadius:"10px"}}>
   <Grid container>
       <Grid md={6} sm={6} xs={6} lg={6}><AttachMoney className={classes.btn} fontSize="medium"/></Grid>
  <Grid md={6} sm={6} xs={6} lg={6}><Box display="flex" justifyContent="flex-end"><Typography className={classes.btn} variant="h6">{c['discount']+"%"}</Typography></Box></Grid>

       <Grid lg={12} md={12} xs={12} sm={12}>
  <Box display="flex" justifyContent="center"><Typography className={classes.title} variant="h6">{c['channel_type']}</Typography></Box>
         
       </Grid>

   </Grid>
    </Box>
</Grid>;
  })}

  <Grid item lg={12} md={12} xs={12} sm={12}>
   
  
  </Grid>
        
    </Grid>
}

</Box>

<Box display="flex" justifyContent="center">
    <Pagination count={10} showFirstButton showLastButton />
    </Box>

    </div>
  );
}

export default withLocalize(Commissions);
